module.exports = __webpack_public_path__ + "static/img/kol-regional.f3a77181.png";